const SALESFORCE_ENDPOINTS = {
    AU: {
        locales: {
            en: {
                development: {
                    "action_contact_url": `https://go.demo.pardot.com/l/247632/2021-04-12/v65`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.com.au/l/212762/2024-06-12/3lsl6b`,
                    "action_new_enquire_endpoint": `https://go.silverchef.com.au/l/212762/2024-06-12/3lsl51`,
                    "action_rental_form": `https://go.demo.pardot.com/l/433333/2022-08-02/jzr`,
                    "action_rental_finance_form": `https://go.demo.pardot.com/l/433333/2022-06-23/j72`,
                    "action_application_form_url": `https://go.demo.pardot.com/l/433333/2022-07-19/jgn?country=Australia&lead_category=Application&process_web_application=true&`,
                },
                production: {
                    "action_contact_url": `https://go.silverchef.com.au/l/212762/2016-07-18/x5`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.com.au/l/212762/2023-08-01/3k7nvm`,
                    "action_new_enquire_endpoint": `https://go.silverchef.com.au/l/212762/2024-06-12/3lsl1t`,
                    "action_rental_form": `https://go.silverchef.com.au/l/212762/2016-07-20/213i`,
                    "action_rental_finance_form": `https://go.silverchef.com.au/l/212762/2022-07-06/3cj4my`,
                    "action_application_form_url": `https://go.silverchef.com.au/l/212762/2019-01-02/2125p8?country=Australia&lead_category=Application&process_web_application=true&`,
                },
            },
        }
    },
    NZ: {
        locales: {
            en: {
                development: {
                    "action_contact_url": `https://go.demo.pardot.com/l/247632/2022-03-01/289h`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.co.nz/l/212762/2024-06-12/3lsl74`,
                    "action_new_enquire_endpoint": `https://go.silverchef.co.nz/l/212762/2024-06-12/3lsl54`,
                    "action_rental_form": `https://go.demo.pardot.com/l/247632/2022-03-01/289k`,
                    "action_rental_finance_form": `https://go.demo.pardot.com/l/247632/2022-03-01/289k`,
                    "action_application_form_url": `https://go-sandbox.silverchef.co.nz/l/433333/2022-12-13/qvk?country=New%20Zealand&lead_category=Application&process_web_application=true&`,
                },
                production: {
                    "action_contact_url": `https://go.silverchef.co.nz/l/212762/2019-01-03/212b76`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.co.nz/l/212762/2023-08-22/3kdw4y`,
                    "action_new_enquire_endpoint": `https://go.silverchef.co.nz/l/212762/2024-06-12/3lsl4j`,
                    "action_rental_form": `https://go.silverchef.co.nz/l/212762/2019-01-04/212bnz`,
                    "action_rental_finance_form": `https://go.silverchef.co.nz/l/212762/2019-01-04/212bnz`,
                    "action_application_form_url": `https://go.silverchef.co.nz/l/212762/2019-01-02/2125qq?country=New%20Zealand&lead_category=Application&process_web_application=true&`,
                },
            },
        }
    },
    CA: {
        locales: {
            en: {
                development: {
                    "action_contact_url": `https://go.demo.pardot.com/l/247632/2022-01-25/27yc`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.ca/l/212762/2024-06-12/3lsl77`,
                    "action_new_enquire_endpoint": `https://go.silverchef.ca/l/212762/2024-06-12/3lsl57`,
                    "action_rental_form": `https://go.demo.pardot.com/l/247632/2022-01-25/27yh`,
                    "action_rental_finance_form": `https://go.demo.pardot.com/l/247632/2022-01-25/27yh`,
                    "action_application_form_url": `https://go-sandbox.silverchef.ca/l/433333/2022-12-13/qvn?country=Canada&lead_category=Application&process_web_application=true&`,
                },
                production: {
                    "action_contact_url": `https://go.silverchef.ca/l/212762/2019-01-03/212b78`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.ca/l/212762/2023-08-22/3kdw4v`,
                    "action_new_enquire_endpoint": `https://go.silverchef.ca/l/212762/2024-06-12/3lsl4m`,
                    "action_rental_form": `https://go.silverchef.ca/l/212762/2019-01-04/212bnl`,
                    "action_rental_finance_form": `https://go.silverchef.ca/l/212762/2019-01-04/212bnl`,
                    "action_application_form_url": `https://go.silverchef.ca/l/212762/2019-01-02/2125rl?country=Canada&lead_category=Application&process_web_application=true&`,
                },
            },
            fr: {
                development: {
                    "action_contact_url": `https://go.demo.pardot.com/l/247632/2022-01-25/27yf`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.ca/l/212762/2024-06-12/3lsl7b`,
                    "action_new_enquire_endpoint": `https://go.silverchef.ca/l/212762/2024-06-12/3lsl5b`,
                    "action_rental_form": `https://go.demo.pardot.com/l/247632/2022-01-25/27yk`,
                    "action_rental_finance_form": `https://go.demo.pardot.com/l/247632/2022-01-25/27yk`,
                    "action_application_form_url": `https://go-sandbox.silverchef.ca/l/433333/2022-12-14/qxk?country=Canada&lead_category=Application&process_web_application=true&language=FR&`,
                },
                production: {
                    "action_contact_url": `https://go.silverchef.ca/l/212762/2020-06-18/2j282n`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.ca/l/212762/2023-09-06/3klbjy`,
                    "action_new_enquire_endpoint": `https://go.silverchef.ca/l/212762/2024-06-12/3lsl4q`,
                    "action_rental_form": `https://go.silverchef.ca/l/212762/2020-07-02/2j7j86`,
                    "action_rental_finance_form": `https://go.silverchef.ca/l/212762/2020-07-02/2j7j86`,
                    "action_application_form_url": `https://go.silverchef.ca/l/212762/2020-07-02/2j7jgv?country=Canada&lead_category=Application&process_web_application=true&language=FR&`,
                },
            }
        }
    },
}

export {SALESFORCE_ENDPOINTS}
